<style lang="scss">
html {scroll-behavior: smooth;}
.zoezi-anchor{
    height:0;
    overflow:hidden;
    opacity:0;
    position:relative;
    transition:opacity 250ms ease-in-out;
    a{
        position:absolute;
        right:10px;
        top:-.75em;
        background:white;
        padding: 0 10px;
    }
    &.visible {
        overflow:visible;
        opacity:1;
        a:before{
            content: attr(name);
        }
        a:after {
            content: ' ⚓️';
        }
    }
}
</style>

<template>
    <div class="zoezi-anchor" :class="{visible : $root.edit}">
        <a :name="name" :id="name"></a>
    </div>
</template>

<script>
export default {
    name: 'zoezi-anchor',
    zoezi: {
        title: 'Anchor',
        icon: 'mdi-anchor'
    },

    props: {
        name: {
            title: 'Anchor name',
            type: String,
            default: function(){
                return 'anchor_'+Math.floor(Math.random()*100);
            }
        }
    }

}
</script>
